import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Field, reduxForm, change, formValueSelector } from 'redux-form';
import submit from './submit';
import validate from './validate';
import { FormattedMessage, injectIntl } from 'react-intl';

// Locale
import messages from '../../locale/messages';

// Redux
import { connect } from 'react-redux';

// Helper
import PopulateData from '../../helpers/populateData';

// Style
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import s from './RegisterForm.css';
import {
  Button,
  Form,
  Row,
  FormGroup,
  Col,
  ControlLabel,
  FormControl,
  Dropdown,
} from 'react-bootstrap';
import Checkbox from '../../components_new/common/FormComponents/Checkbox';

class RegisterForm extends Component {
  static propTypes = {
    formatMessage: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  renderFormControl = ({
    input,
    label,
    type,
    meta: { touched, error },
    className,
  }) => {
    const { formatMessage } = this.props.intl;
    return (
      <div>
        {touched && error && (
          <span className={s.errorMessage}>{formatMessage(error)}</span>
        )}
        <FormControl
          {...input}
          placeholder={label}
          type={type}
          className={className}
        />
      </div>
    );
  };
  renderCheckbox = ({
    input,
    label,
    type,
    meta: { touched, error },
    className,
  }) => {
    const { formatMessage } = this.props.intl;
    return (
      <div>
        {touched && error && (
          <span className={s.errorMessage}>{formatMessage(error)}</span>
        )}
        <Checkbox
          onChange={val => this.props.change('age', val)}
          checked={this.props.age}
          label="I verify that I am at least 18 years of age."
          {...input}
        />
      </div>
    );
  };

  renderFormControlSelect = ({
    input,
    label,
    meta: { touched, error },
    children,
  }) => {
    const { formatMessage } = this.props.intl;
    return (
      <div>
        <FormControl componentClass="select" {...input}>
          {children}
        </FormControl>
      </div>
    );
  };

  render() {
    const { error, handleSubmit, submitting, dispatch } = this.props;
    const { formatMessage } = this.props.intl;

    return (
      <form onSubmit={handleSubmit(submit)}>
        {error && (
          <span className={s.errorMessage}>{formatMessage(error)}</span>
        )}
        <FormGroup className={s.formGroup}>
          <Field
            name="firstName"
            type="text"
            component={this.renderFormControl}
            label={formatMessage(messages.firstName)}
            className={s.formControlInput}
          />
        </FormGroup>
        <FormGroup className={s.formGroup}>
          <Field
            name="lastName"
            type="text"
            component={this.renderFormControl}
            label={formatMessage(messages.lastName)}
            className={s.formControlInput}
          />
        </FormGroup>
        <FormGroup className={s.formGroup}>
          <Field
            name="email"
            type="text"
            component={this.renderFormControl}
            label={formatMessage(messages.email)}
            className={s.formControlInput}
          />
        </FormGroup>
        <FormGroup className={s.formGroup}>
          <Field
            name="password"
            type="password"
            component={this.renderFormControl}
            label={formatMessage(messages.password)}
            className={s.formControlInput}
          />
        </FormGroup>

        <FormGroup className={s.formGroup} id="register-age-verification" >
          <Field name="age" component={this.renderCheckbox} />
        </FormGroup>

        <FormGroup className={s.formGroup}>
          <Button
            className={cx(s.button, s.btnPrimary)}
            bsSize="large"
            block
            type="submit"
            disabled={submitting}
          >
            {formatMessage(messages.signUp)}
          </Button>
        </FormGroup>
      </form>
    );
  }
}

const selector = formValueSelector('RegisterForm');

RegisterForm = reduxForm({
  form: 'RegisterForm', // a unique name for this form
  validate,
})(RegisterForm);

export default injectIntl(
  connect(
    state => ({
      age: selector(state, 'age')
    }),
    { change },
  )(withStyles(s)(RegisterForm)),
);



// WEBPACK FOOTER //
// ./src/components/RegisterForm/RegisterForm.js